namespace GeniuzPOS.Product {
    export class PsSetItemColumns {
        static columnsKey = 'Product.PsSetItem';
    }
}
